import { Alert } from "@mui/material";
import { useTranslation } from 'react-i18next';

function Instructions({ show = true }) {
  const { t } = useTranslation();
  if (!show) return null;
  
  return (
    <Alert
      sx={{
        '& .MuiAlert-icon': {
          fontSize: 40,
          color: '#1B8FFF',
        },
      }}
      severity="info"
    >
      {t('checkout.home.map.instruction')}
    </Alert>
  );
}

export default Instructions;
